import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { IoMdHome } from 'react-icons/io';
import { FiLogOut } from 'react-icons/fi';
import { useAuth } from './Utilities/authContext';
import { logout } from './Utilities/api';

import './privateRoute.css';

const PrivateRoute = ({ element, elName }) => {
  const navigate = useNavigate();
  const { user, setUser } = useAuth();

  useEffect(() => {
    if (!localStorage.getItem('jwt')) {
      navigate('/');
    }
  }, [navigate]);

  const handleLogout = () => {
    logout();
    setUser(null);
    navigate('/');
  };

  const initial = user?.name ? user.name.charAt(0).toUpperCase() : '?';

  return (
    <div className="private-route-container">
      <div className="navbar">
        <div className="navbar-left">
          <div
            className={elName === 'dashboard' ? 'nav-item selected' : 'nav-item'}
            onClick={() => navigate('/dashboard')}
            title="Dashboard"
          >
            <IoMdHome />
          </div>
        </div>
        <div className="navbar-brand">Single Short</div>
        <div className="navbar-right">
          <div className="nav-user" title={user?.email || ''}>
            <div className="nav-user-avatar">{initial}</div>
            <div className="nav-user-name">{user?.name || ''}</div>
          </div>
          <div className="nav-item" onClick={handleLogout} title="Log out">
            <FiLogOut />
          </div>
        </div>
      </div>
      <div className="background">
        <div className="page-container">{element}</div>
      </div>
    </div>
  );
};

export default PrivateRoute;
